module.exports = "/_next/static/images/DefaultProductImageStore-e9629ecb7413dd748d1d58fc18719ef4.webp";